import { render, staticRenderFns } from "./e-mail-overview.vue?vue&type=template&id=04a5f9d9&"
import script from "./e-mail-overview.vue?vue&type=script&lang=js&"
export * from "./e-mail-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports